/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getInstitutions } from 'app/entities/institution/institution.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { createEntity, getEntity, reset, updateEntity } from './hospital-institution.reducer';

export const HospitalInstitutionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const institutions = useAppSelector(state => state.institution.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const hospitalInstitutionEntity = useAppSelector(state => state.hospitalInstitution.entity);
  const loading = useAppSelector(state => state.hospitalInstitution.loading);
  const updating = useAppSelector(state => state.hospitalInstitution.updating);
  const updateSuccess = useAppSelector(state => state.hospitalInstitution.updateSuccess);

  const handleClose = () => {
    navigate(`/hospital-institution${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getInstitutions({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.allowedCredit !== undefined && typeof values.allowedCredit !== 'number') {
      values.allowedCredit = Number(values.allowedCredit);
    }
    if (values.maxCreditLimit !== undefined && typeof values.maxCreditLimit !== 'number') {
      values.maxCreditLimit = Number(values.maxCreditLimit);
    }
    if (values.standardCreditLimit !== undefined && typeof values.standardCreditLimit !== 'number') {
      values.standardCreditLimit = Number(values.standardCreditLimit);
    }
    if (values.openingBalance !== undefined && typeof values.openingBalance !== 'number') {
      values.openingBalance = Number(values.openingBalance);
    }
    values.microSec = convertDateTimeToServer(values.microSec);
    values.timestampEntry = convertDateTimeToServer(values.timestampEntry);
    values.lastUpdated = convertDateTimeToServer(values.lastUpdated);
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...hospitalInstitutionEntity,
      ...values,
      institution: institutions.find(it => it.id.toString() === values.institution?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          microSec: displayDefaultDateTime(),
          timestampEntry: displayDefaultDateTime(),
          lastUpdated: displayDefaultDateTime(),
        }
      : {
          ...hospitalInstitutionEntity,
          microSec: convertDateTimeFromServer(hospitalInstitutionEntity.microSec),
          timestampEntry: convertDateTimeFromServer(hospitalInstitutionEntity.timestampEntry),
          lastUpdated: convertDateTimeFromServer(hospitalInstitutionEntity.lastUpdated),
          institution: hospitalInstitutionEntity?.institution?.id,
          hospital: hospitalInstitutionEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.hospitalInstitution.home.createOrEditLabel" data-cy="HospitalInstitutionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.hospitalInstitution.home.createOrEditLabel">
              Create or edit a HospitalInstitution
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="hospital-institution-id"
                  label={translate('tinyMedicRestApp.hospitalInstitution.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.accountHolderName')}
                id="hospital-institution-accountHolderName"
                name="accountHolderName"
                data-cy="accountHolderName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.accountNo')}
                id="hospital-institution-accountNo"
                name="accountNo"
                data-cy="accountNo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.ifscCode')}
                id="hospital-institution-ifscCode"
                name="ifscCode"
                data-cy="ifscCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.allowedCredit')}
                id="hospital-institution-allowedCredit"
                name="allowedCredit"
                data-cy="allowedCredit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.maxCreditLimit')}
                id="hospital-institution-maxCreditLimit"
                name="maxCreditLimit"
                data-cy="maxCreditLimit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.standardCreditLimit')}
                id="hospital-institution-standardCreditLimit"
                name="standardCreditLimit"
                data-cy="standardCreditLimit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.openingBalance')}
                id="hospital-institution-openingBalance"
                name="openingBalance"
                data-cy="openingBalance"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.overDraft')}
                id="hospital-institution-overDraft"
                name="overDraft"
                data-cy="overDraft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.inactive')}
                id="hospital-institution-inactive"
                name="inactive"
                data-cy="inactive"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.active')}
                id="hospital-institution-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.microSec')}
                id="hospital-institution-microSec"
                name="microSec"
                data-cy="microSec"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.timestampEntry')}
                id="hospital-institution-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.lastUpdated')}
                id="hospital-institution-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalInstitution.cursor')}
                id="hospital-institution-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="hospital-institution-institution"
                name="institution"
                data-cy="institution"
                label={translate('tinyMedicRestApp.hospitalInstitution.institution')}
                type="select"
              >
                <option value="" key="0" />
                {institutions
                  ? institutions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-institution-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.hospitalInstitution.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/hospital-institution" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HospitalInstitutionUpdate;
